<template>
  <v-flex xs12 sm6 md4 lg3>
    <v-card class="text-center ma-3" color="#F4F8FF">
      <v-card-title>
        <v-row align="center" no-gutters>
          <v-col cols="auto">
            <!-- Icon -->
            <!-- <v-icon color="primary">mdi-message-text</v-icon> -->
            <v-btn fab depressed small dark color="#fff">
              <v-icon color="#00B3FF">mdi-message-text-fast</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <!-- Name -->
            <div align="left" class="ml-4">
              <span class="text-h6 subheading cardText--text">TextPay</span>
            </div>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text align="left" class="ml-3">
        <!-- Amount -->
        <div
          v-if="textPay"
          class="text-h6 cardTextAccent1--text font-weight-bold"
        >
          Kes. {{ textPay.data.textPay.balance.toFixed(1) }}
        </div>
        <div v-else class="text-h6 cardTextAccent1--text font-weight-bold">
          Kes. 0
        </div>
      </v-card-text>
    </v-card>
  </v-flex>
</template>
<script>
export default {
  created() {
    this.$store.dispatch("wallets/fetchTextPay");
  },
  computed: {
    textPay() {
      return this.$store.getters["wallets/textPay"];
    },
  },
};
</script>
